import sanitizeHtml from 'sanitize-html';
import * as sanitizeOptions from './sanitizeOptions';

const allSanitizeRules = {
    transformTags: sanitizeOptions.transformTags,
    allowedAttributes: sanitizeOptions.allowed.attributes,
    allowedIframeDomains: sanitizeOptions.allowed.iframeDomains,
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(sanitizeOptions.allowed.tags),
    allowedStyles: sanitizeOptions.allowed.styles
};

const sanitize = (htmlString) => sanitizeHtml(htmlString, allSanitizeRules);
export default sanitize;
